import React, { FunctionComponent } from 'react'

import { Check, Spinner } from './icon'
import styles from './style.module.scss'

interface Props {
  show?: boolean
}
export const Checkmark: FunctionComponent<Props> = ({ show = false }) => {
  return show ? (
    <div className={styles.wrapper}>
      <div className={styles.spinnerWrapper}>
        <Spinner className={styles.spinner} />
      </div>
      <div className={styles.checkmarkWrapper}>
        <Check className={styles.checkmark} />
      </div>
    </div>
  ) : null
}
